import JourneySteps from "@/components/JourneySteps";
import StudentJourneyStrip from "@/components/StudentJourneyStrip";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function HowItWorks() {
  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16" data-testid="how-it-works-page">
      <div className="max-w-3xl mb-14">
        <p className="text-sm font-bold text-teal-600 uppercase tracking-widest mb-3">How It Works</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-[1.05]">
          Your Global <span className="text-orange-500">Learning Journey</span>
        </h1>
        <p className="mt-5 text-slate-600">Ten simple steps from your first click to the day you return home with a global perspective, new skills, and international connections.</p>
      </div>

      <div className="grid lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2">
          <JourneySteps />
        </div>
        <aside className="lg:col-span-1">
          <div className="rounded-3xl bg-gradient-to-br from-blue-600 to-purple-600 text-white p-8 sticky top-24">
            <h3 className="font-display text-2xl font-extrabold mb-3">Ready to start?</h3>
            <p className="text-white/85 text-sm leading-relaxed mb-6">Submit your application in minutes and our team will get in touch with next steps.</p>
            <Link to="/apply" data-testid="how-it-works-apply-cta" className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white text-slate-900 font-semibold text-sm">
              Apply Now <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </aside>
      </div>

      <section className="mt-24">
        <p className="text-sm font-bold text-purple-600 uppercase tracking-widest mb-3">Interactive Journey</p>
        <h2 className="font-display text-3xl font-extrabold text-slate-900 mb-8">From home country to global classroom</h2>
        <StudentJourneyStrip />
      </section>
    </div>
  );
}
